import { ChangeEvent, useEffect, useState } from "react";
import styled from "styled-components";
import { List as ListModel } from "../models/post";
import List from "../components/list";

export const AddListItemButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .75rem;
  background: white;
  cursor: pointer;
  transition: .1s;
  font-size: 1.1rem;
  font-weight: bold;
  width: 100%;
  &:hover {
    background: #f5f5f5;
  }
`;

export const ListItem = styled.input`
  appearance: none;
  background: white;
  font-size: 1.1rem;
  font-weight: 600;
  padding: .75rem;
  width: 100%;
  border: none;
  &::placeholder {
    font-weight: bold;
    color: rgb(200,200,200);
  }
  &:focus {
    outline: none;
  }
`;

export const ListActionRow = styled.div`
  display: grid;
  gap: 1px;
  grid-auto-flow: column;
`;

export default function ListComponent(props: {
  list: ListModel;
  update: (list: string[]) => void;
  deleteContent: () => void;
}) {
  const [items, setItems] = useState<string[]>([]);

  const addItem = () => {
    setItems(i => [...i, ""]);
  };

  const deleteItem = () => {
    if (items.length === 0) {
      props.deleteContent();
      return;
    }
    setItems(i => {
      const copy = [...i];
      copy.pop();
      return copy;
    });
  };

  const onChange = (index: number) => (e: ChangeEvent<HTMLInputElement>) => {
    setItems(items => {
      const copy = [...items];
      copy[index] = e.target.value;
      return copy;
    });
  }

  useEffect(() => {
    props.update(items);
  }, [items, props]);

  return <List>
    {items.map((item, index) => <ListItem key={index} value={item} onChange={onChange(index)}placeholder="Listeneintrag eingeben..." />)}

    <ListActionRow>
      <AddListItemButton onClick={deleteItem} style={{
        color: "#e92b54"
      }}>
        {items.length === 0 ? "Liste" : "Eintrag"} löschen
      </AddListItemButton>
      <AddListItemButton onClick={addItem} style={{
        color: "#1eb167"
      }}>
        Eintrag hinzufügen
      </AddListItemButton>
    </ListActionRow>

  </List>;
}
